import { useTranslation } from "react-i18next";

const LOGO_URL = "/logo.png";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-6">
              <img src={LOGO_URL} alt="Logo" className="h-8 w-auto" />
              <span className="text-lg font-black text-slate-900 uppercase tracking-tighter">PT. Lentera Sastra Loka</span>
            </div>
            <p className="text-slate-500 max-w-xs text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>
          
          <div className="md:col-span-2">
            <h5 className="text-[12px] font-bold mb-6 text-slate-900 uppercase tracking-wider">{t('footer.services')}</h5>
            <ul className="space-y-4 text-sm text-slate-500 font-medium">
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.services_items.0')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.services_items.1')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.services_items.2')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.services_items.3')}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h5 className="text-[12px] font-bold mb-6 text-slate-900 uppercase tracking-wider">{t('footer.company')}</h5>
            <ul className="space-y-4 text-sm text-slate-500 font-medium">
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.company_items.0')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.company_items.1')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.company_items.2')}</a></li>
              <li><a className="hover:text-primary-container transition-colors" href="#">{t('footer.company_items.3')}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="text-[12px] font-bold mb-6 text-slate-900 uppercase tracking-wider">{t('footer.contact_info.title')}</h5>
            <div className="space-y-4 text-sm text-slate-500 font-medium">
              <p>{t('footer.contact_info.location')}</p>
              <p>{t('footer.contact_info.email')}</p>
              <p>{t('footer.contact_info.phone')}</p>
            </div>
          </div>
        </div>
        <div className="md:flex md:items-center md:justify-between pt-8 border-t border-slate-100">
          <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 mb-4 md:mb-0">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}